export const fallbackLng = 'fr'
export const languages = [fallbackLng, 'en', 'es']
export const defaultNS = 'translation'

export const defaultModelRegionCode = 'FR'
